import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import {
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY
} from 'mailup-web-components'
import { modalResetSendState } from 'Pages/EmailSendingWizard/recoil/state/modals'
import { eraseSelectedSegmentCallback } from 'Pages/EmailSendingWizard/recoil/callbacks/callback'
import { senderInfoState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'
import { useHistory } from 'react-router-dom'

export const ModalResetSend = () => {
  const intl = useIntl()
  const { show } = useRecoilValue(modalResetSendState)
  const history = useHistory()
  const resetModal = useResetRecoilState(modalResetSendState)
  const { lastSendingId } = useRecoilValue(senderInfoState)
  const eraseSelectedSegment = useRecoilCallback(
    eraseSelectedSegmentCallback,
    []
  )

  const handlePrevQueueModalReset = () => {
    eraseSelectedSegment()

    resetModal()
  }

  const handlePrevQueueModalGoToPlan = () => {
    resetModal()
    history.push(`/messages/email/queue-manage/${lastSendingId}`)
  }

  return (
    <Modal
      show={show}
      onClose={resetModal}
      className='b-modal--filter-details'
      data-mu-test='modal-filter-details'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.EmailSendingWizard.PrevQueueModalTitle'
        })}
      />

      <ModalBody>
        <p>
          {intl.formatMessage(
            {
              id: 'Load.EmailSendingWizard.PrevQueueModalBody'
            },
            {
              strong: val => <strong>{val}</strong>
            }
          )}
        </p>
      </ModalBody>

      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={handlePrevQueueModalGoToPlan}
          data-mu-test='btn-PrevQueueModalGoToPlan'
        >
          {intl.formatMessage({
            id: 'Load.EmailSendingWizard.PrevQueueModalGoToPlan'
          })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handlePrevQueueModalReset}
          data-mu-test='btn-PrevQueueModalReset'
        >
          {intl.formatMessage({
            id: 'Load.EmailSendingWizard.PrevQueueModalReset'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
